<template>
  <div id="popup">
    <div class="colored-top" :style="'background-image: url(' + overlayImage +')'" >
      <modal-actions :back-action="backAction" :close-action="closeAction" :dark-text="darkText" />
      <slot name="top-content"></slot>
    </div>
    <div class="bottom" :class="{ [layout]: layout, rounded: !hasFooterSlot }">
        <slot name="bottom-content"></slot>
    </div>

    <template v-if="hasFooterSlot">
      <separator/>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </div>
</template>

<script>
import ModalActions from '../ModalActions.vue';
import Separator from '../Separator.vue';

export default {
  name: 'ColoredPopup',
  components: {
    ModalActions,
    Separator,
  },
  props: {
    closeAction: {
      type: Function,
      require: false,
      default: null,
    },
    backAction: {
      type: Function,
      require: false,
      default: null,
    },
    darkText: {
      type: Boolean,
      require: false,
      default: null,
    },
    layout: {
      type: String,
      default: 'content-padding',
      validator: val => ['content-padding', 'no-content-padding'].includes(val),
    },
    overlayImage: {
      type: String,
      require: false,
    },
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'colored-popup';
</style>
